import { Checkbox, Fab, FormControlLabel, Grid } from "@material-ui/core";
import { Add, Clear, Delete, Edit } from "@material-ui/icons";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import {
  getDateFormats,
  getDateTimeLocale,
  getInputDateFormats,
} from "../../../../../utils/get-date-time-locale";

import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";

import { withRouter } from "react-router-dom";
import { authProvider } from "../../../../../authProvider";
import { useAuth } from "../../../../../context/auth";
import { actionShowSpinner } from "../../../../../redux-flow/action/Wrapper/Spinner";
import { getMembersByName } from "../../../../../services/formCombos.service.js";
import {
  createAction,
  createActionReview,
  createActionReviewOnFinishedMinute,
  deleteAction,
  getById,
} from "../../../../../services/minutes.service.js";
import { Select } from "../../../../Common/Select";
import { Table } from "../../../../Common/Table";
import Textarea from "../../../../Common/Textarea";
import Toastmessage from "../../../../Common/ToastMessage";
import ModalBase from "../../../utils/ModalBase";
import { checkAccess } from "../../../utils/index";
import ReviewsModal from "./ReviewsModal";

const Actions = ({
  t,
  minuteStatus,
  actionShowSpinner,
  actions = [],
  minuteSlotId,
  updateData,
  isEditMode = true,
}) => {
  const { userAccess } = useAuth();
  const history = useHistory();
  const { i18n } = useTranslation();

  const columns = [
    {
      title: t("forms.requester").toUpperCase(),
      field: "actionRequester",
    },
    {
      title: t("forms.minutes.actions.responsibleName").toUpperCase(),
      field: "firstResponsible",
    },
    {
      title: t("forms.minutes.actions.secoundResponsibleName").toUpperCase(),
      field: "secoundResponsible",
    },
    {
      title: t("forms.actionNumber").toUpperCase(),
      field: "actionNumber",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      title: t("forms.minutes.actions.action").toUpperCase(),
      field: "action",
      cellStyle: {
        width: 200,
        maxWidth: 200,
        wordWrap: "break-word",
      },
    },
    {
      title: t("forms.minutes.actions.deadline").toUpperCase(),
      field: "deadline",
      render: (rowData) => {
        return format(
          new Date(rowData.deadline),
          getDateFormats(i18n.language),
          {
            locale: getDateTimeLocale(i18n.language),
          }
        );
      },
    },
  ];

  const [formData, setFormData] = useState({
    actionId: null,
    requesterName: "",
    reviewerRequester: "",
    anyoneCanRequest: false,
    firstResponsibleName: "",
    reviewerRequesterId: "",
    secoundResponsibleName: "",
    action: "",
    selectedDeadline: new Date(),
  });

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });
  const [openReviewsModal, setOpenReviewsModal] = useState(false);
  const [creatingAction, setCreatingAction] = useState(false);
  const [formattedActions, setFormattedActions] = useState([]);
  const [numberOfReviews, setNumberOfReviews] = useState(0);
  const [requesters, setRequesters] = useState([]);
  const [inputRequesterName, setInputRequesterName] = useState("");
  const [reviewRequesters, setReviewRequesters] = useState([]);
  const [inputReviewerRequester, setInputReviewerRequester] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [firstResponsibles, setFirstResponsibles] = useState([]);
  const [secoundResponsibles, setSecoundResponsibles] = useState([]);
  const [inputFirstResponsibleName, setInputFirstResponsibleName] =
    useState("");
  const [inputSecoundResponsibleName, setInputSecoundResponsibleName] =
    useState("");
  const [canCreateAction, setCanCreateAction] = useState(false);
  const [canCreateActionRevision, setCanCreateActionRevision] = useState(false);
  const [canDeleteActionInMinutes, setCanDeleteActionInMinutes] =
    useState(false);

  useEffect(() => {
    const reviews = [];
    actionShowSpinner(true);

    if (userAccess) {
      const hasAccessToList = checkAccess(userAccess, "listActionsInMinutes");
      const hasAccessToCreateAction = checkAccess(userAccess, "createAction");
      const hasAccessToCreateActionRevision = checkAccess(
        userAccess,
        "createActionRevision"
      );
      const hasAccessToDeleteActionInMinutes = checkAccess(
        userAccess,
        "deleteActionInMinutes"
      );

      setCanCreateAction(hasAccessToCreateAction && minuteStatus !== "C");
      setCanCreateActionRevision(hasAccessToCreateActionRevision);
      setCanDeleteActionInMinutes(
        hasAccessToDeleteActionInMinutes && minuteStatus !== "C"
      );

      if (!hasAccessToList) {
        history.push("/minutes");
      }

      actions.forEach((action) => {
        if (action?.actionHistory) {
          reviews.push(...action?.actionHistory);
        }
      });

      setFormattedActions(
        actions.map((action) => ({
          ...action,
          actionRequester: action?.anyoneCanRequest
            ? t("menu.slot.anyone")
            : action?.actionRequester,
        }))
      );
      setNumberOfReviews(reviews.length);

      actionShowSpinner(false);
    }
  }, [actions, minuteStatus, userAccess, history, i18n.language]);

  useEffect(() => {
    async function load() {
      if (inputReviewerRequester?.length >= 3) {
        const res = await getMembersByName("pt", inputReviewerRequester);

        if (res.error?.length > 0) {
          setReviewRequesters([]);
        }

        const list = res.data;

        setReviewRequesters(list);
      } else {
        setReviewRequesters([]);
      }
    }

    load();
  }, [inputReviewerRequester]);

  useEffect(() => {
    async function load() {
      if (inputRequesterName?.length >= 3) {
        const res = await getMembersByName("pt", inputRequesterName);

        if (res.error?.length > 0) {
          setRequesters([]);

          return;
        }

        const list = res.data;

        setRequesters(list);
      } else {
        setRequesters([]);
      }
    }

    load();
  }, [inputRequesterName]);

  useEffect(() => {
    async function load() {
      if (inputFirstResponsibleName?.length >= 3) {
        const res = await getMembersByName("pt", inputFirstResponsibleName);

        if (res.error?.length > 0) {
          setFirstResponsibles([]);

          return;
        }

        const list = res.data;

        setFirstResponsibles(list);
      } else {
        setFirstResponsibles([]);
      }

      if (inputSecoundResponsibleName?.length >= 3) {
        const res = await getMembersByName("pt", inputSecoundResponsibleName);

        if (res.error?.length > 0) {
          setSecoundResponsibles([]);

          return;
        }

        const list = res.data;

        setSecoundResponsibles(list);
      } else {
        setSecoundResponsibles([]);
      }
    }

    load();
  }, [inputFirstResponsibleName, inputSecoundResponsibleName]);

  const loadActions = async () => {
    actionShowSpinner(true);

    const res = await getById(minuteSlotId);

    const formatActions = [];

    if (res?.actions) {
      for (const action of res?.actions) {
        formatActions.push({
          ...action,
          firstResponsible: action?.firstResponsible
            ? action?.firstResponsible
            : "",
          secoundResponsible: action?.secondResponsible
            ? action?.secondResponsible
            : "",
          actionRequester: action?.anyoneCanRequest
            ? t("menu.slot.anyone")
            : action?.actionRequester,
        });
      }
    }

    const reviews = [];

    formatActions.forEach((action) => {
      if (action?.actionHistory) {
        reviews.push(...action?.actionHistory);
      }
    });

    setNumberOfReviews(reviews.length);

    setFormattedActions(formatActions);

    actionShowSpinner(false);

    updateData();
  };

  const handleAddAction = async () => {
    actionShowSpinner(true);

    if (
      !formData.selectedDeadline ||
      (!formData.requesterName.id && !formData.anyoneCanRequest) ||
      !formData.action
    ) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.votesValidatioError"),
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);
      return;
    }

    const newAction = {
      id: minuteSlotId,
      ...(formData?.requesterName?.id && {
        requesterId: formData?.requesterName?.id,
      }),
      ...(formData?.firstResponsibleName?.id && {
        firstResponsibleId: formData?.firstResponsibleName?.id,
      }),
      ...(formData?.secoundResponsibleName?.id && {
        secoundResponsibleId: formData?.secoundResponsibleName?.id,
      }),
      ...(formData?.action && { actionDecription: formData?.action }),
      ...(formData?.selectedDeadline && {
        deadline: formData?.selectedDeadline,
      }),
      ...(formData?.anyoneCanRequest && {
        anyoneCanRequest: formData?.anyoneCanRequest,
      }),
    };

    setCreatingAction(true);
    const res = await createAction(newAction);
    setCreatingAction(false);

    setEditMode(false);

    if (res.error) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.addActionError"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }
    loadActions();

    setMessage({
      open: true,
      content: t("forms.minutes.actions.addActionSuccess"),
      type: "success",
      autoHideDuration: 4000,
    });

    setFormData({
      requesterName: "",
      reviewerRequester: "",
      firstResponsibleName: "",
      reviewerRequesterId: "",
      secoundResponsibleName: "",
      action: "",
      selectedDeadline: new Date(),
      anyoneCanRequest: false,
    });
  };

  const handleCancelReview = () => {
    setEditMode(false);

    setFormData({
      requesterName: "",
      reviewerRequester: "",
      firstResponsibleName: "",
      reviewerRequesterId: "",
      secoundResponsibleName: "",
      action: "",
      selectedDeadline: new Date(),
      anyoneCanRequest: false,
    });

    const reviews = [];

    formattedActions.forEach((action) => {
      reviews.push(...action.reviews);
    });
  };

  const handleAddReview = async () => {
    if (!formData.reviewerRequester.id) {
      setMessage({
        open: true,
        content: t(
          "forms.minutes.actions.addActionsReviewerRequesterFieldValidation"
        ),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    if (
      !formData.actionId ||
      (!formData.requesterName?.id && !formData.anyoneCanRequest) ||
      !formData.action
    ) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.votesValidatioError"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    setCreatingAction(true);

    let res;

    if (minuteStatus === "C") {
      const updateResponsiblesPayload = {
        ...(formData?.actionId && { actionId: formData?.actionId }),
        ...(formData?.firstResponsibleName?.id && {
          firstResponsibleId: formData?.firstResponsibleName?.id,
        }),
        ...(formData?.secoundResponsibleName?.id && {
          secoundResponsibleId: formData?.secoundResponsibleName?.id,
        }),
        ...(formData?.reviewerRequester?.id && {
          reviewRequester: formData?.reviewerRequester?.id,
        }),
        ...(formData?.anyoneCanRequest && {
          anyoneCanRequest: formData?.anyoneCanRequest,
        }),
      };

      res = await createActionReviewOnFinishedMinute(updateResponsiblesPayload);
    } else {
      const newReview = {
        ...(formData?.actionId && { actionId: formData?.actionId }),
        ...(formData?.requesterName?.id && {
          member_Requester: formData?.requesterName?.id,
        }),
        ...(formData?.firstResponsibleName?.id && {
          member_Responsible1: formData?.firstResponsibleName?.id,
        }),
        ...(formData?.secoundResponsibleName?.id && {
          member_Responsible2: formData?.secoundResponsibleName?.id,
        }),
        ...(formData?.action && { description: formData?.action }),
        ...(formData?.selectedDeadline && {
          deadline: formData?.selectedDeadline,
        }),
        ...(formData?.reviewerRequester?.id && {
          member_Requester_Reviewer: formData?.reviewerRequester?.id,
        }),
        ...(formData?.anyoneCanRequest && {
          anyoneCanRequest: formData?.anyoneCanRequest,
        }),
        member_Reviewer: authProvider?.account?.accountIdentifier,
      };

      res = await createActionReview(newReview);
    }

    setCreatingAction(false);

    if (res?.error) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.addActionReviewError"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    loadActions();

    setEditMode(false);

    setMessage({
      open: true,
      content: t("forms.minutes.actions.addReviewSuccess"),
      type: "success",
      autoHideDuration: 4000,
    });

    setFormData({
      requesterName: "",
      reviewerRequester: "",
      firstResponsibleName: "",
      reviewerRequesterId: "",
      secoundResponsibleName: "",
      action: "",
      selectedDeadline: new Date(),
      anyoneCanRequest: false,
    });
  };

  const handleDeleteAction = async (rowData) => {
    actionShowSpinner(true);

    const response = await deleteAction(rowData.id);

    if (response.error) {
      setMessage({
        open: true,
        content: t("error"),
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);
      return;
    }

    loadActions();

    setMessage({
      open: true,
      content: "Ação excluida com sucesso.",
      type: "success",
      autoHideDuration: 4000,
    });

    actionShowSpinner(false);
  };

  return (
    <>
      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <ModalBase
        open={openReviewsModal}
        setOpen={setOpenReviewsModal}
        content={
          <ReviewsModal
            t={t}
            setModalStatus={(value) => setOpenReviewsModal(value)}
            actions={formattedActions}
          />
        }
      />
      {isEditMode && (
        <Grid container direction="row" spacing={3}>
          <Grid item lg={numberOfReviews > 0 ? 8 : 12} xs={12}>
            <Grid container spacing={3}>
              {!formData.anyoneCanRequest && (
                <Grid item lg={6} xs={12}>
                  <Select
                    value={formData?.requesterName}
                    disabled={minuteStatus === "C" || !canCreateAction}
                    setValue={(value) => {
                      setFormData({ ...formData, requesterName: value });
                    }}
                    id="requesterName"
                    onInputChange={(_event, newInputValue, _prop) => {
                      setInputRequesterName(newInputValue);
                    }}
                    inputValue={inputRequesterName}
                    options={requesters ? requesters : []}
                    label={t("forms.minutes.actions.requesterName")}
                    required
                    error={
                      formData?.requesterName?.length < 1 &&
                      minuteStatus !== "C" &&
                      canCreateAction
                    }
                  />
                </Grid>
              )}

              <Grid item lg={3} xs={12}>
                <Select
                  value={formData?.firstResponsibleName}
                  disabled={minuteStatus === "C" || !canCreateAction}
                  setValue={(value) => {
                    setFormData({ ...formData, firstResponsibleName: value });
                  }}
                  id="responsibleName"
                  options={firstResponsibles}
                  inputValue={inputFirstResponsibleName}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputFirstResponsibleName(newInputValue);
                  }}
                  label={t("forms.minutes.actions.responsibleName")}
                />
              </Grid>

              <Grid item lg={3} xs={12}>
                <Select
                  value={formData?.secoundResponsibleName}
                  disabled={minuteStatus === "C" || !canCreateAction}
                  setValue={(value) => {
                    setFormData({ ...formData, secoundResponsibleName: value });
                  }}
                  id="secoundResponsibleName"
                  options={secoundResponsibles}
                  inputValue={inputSecoundResponsibleName}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputSecoundResponsibleName(newInputValue);
                  }}
                  label={t("forms.minutes.actions.secoundResponsibleName")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Textarea
                  name="action"
                  onChange={(e) =>
                    setFormData({ ...formData, action: e.target.value })
                  }
                  value={formData?.action}
                  disabled={minuteStatus === "C" || !canCreateAction}
                  label={t("forms.minutes.actions.actionDescription")}
                  required
                  error={
                    formData?.action?.length < 1 &&
                    minuteStatus !== "C" &&
                    canCreateAction
                  }
                />
              </Grid>

              <Grid item lg={3} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  label={t("forms.minutes.actions.deadline")}
                  value={formData.selectedDeadline}
                  disabled={minuteStatus === "C" || !canCreateAction}
                  onChange={(date) => {
                    setFormData({ ...formData, selectedDeadline: date });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  required
                  error={formData?.selectedDeadline < 1}
                />
              </Grid>

              {editMode && (
                <Grid item lg={3} xs={12}>
                  <Select
                    value={formData?.reviewerRequester}
                    setValue={(value) => {
                      setFormData({ ...formData, reviewerRequester: value });
                    }}
                    id="reviewerRequester"
                    onInputChange={(_event, newInputValue, _prop) => {
                      setInputReviewerRequester(newInputValue);
                    }}
                    inputValue={inputReviewerRequester}
                    options={reviewRequesters}
                    required={true}
                    label={t("forms.minutes.actions.reviewerRequester")}
                    error={!formData.reviewerRequester}
                  />
                </Grid>
              )}
            </Grid>

            <div
              style={{
                display: "flex",
                marginTop: "62px",
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                fullWidth
                control={
                  <Checkbox
                    value={formData.anyoneCanRequest}
                    checked={formData.anyoneCanRequest}
                    onChange={() =>
                      setFormData({
                        ...formData,
                        anyoneCanRequest: !formData.anyoneCanRequest,
                      })
                    }
                    name="roundRobin"
                    id="roundRobin"
                    disabled={minuteStatus === "C" || !canCreateAction}
                    color="primary"
                  />
                }
                label={t("anyoneCanRequest")}
              />

              {!editMode ? (
                <div>
                  <Fab
                    color="primary"
                    aria-label="add"
                    size="small"
                    style={{ marginRight: "10px" }}
                    onClick={handleAddAction}
                    disabled={creatingAction || !canCreateAction}
                  >
                    <Add />
                  </Fab>

                  <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                    {t("forms.minutes.actions.addAction")}
                  </span>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      maxWidth: "200px",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Fab
                      color="primary"
                      aria-label="add"
                      size="small"
                      style={{ marginRight: "10px" }}
                      onClick={handleAddReview}
                      disabled={!canCreateActionRevision || creatingAction}
                    >
                      <Add />
                    </Fab>
                    <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                      {t("forms.minutes.actions.addReview")}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      maxWidth: "200px",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Fab
                      color="primary"
                      aria-label="add"
                      size="small"
                      style={{ marginRight: "10px" }}
                      onClick={handleCancelReview}
                    >
                      <Clear />
                    </Fab>
                    <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                      {t("forms.minutes.actions.cancelReview")}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Grid>

          <Grid item lg={4}>
            {numberOfReviews > 0 && (
              <div
                style={{
                  border: "2px solid #bdbdbd",
                  marginBottom: "8px",
                  borderRadius: "8px",
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "16px", overflowWrap: "break-word" }}>
                  {t("forms.minutes.actions.actionsReviewsTextP1")}
                  <strong>{` ${numberOfReviews} `}</strong>
                  {t("forms.minutes.actions.actionsReviewsTextP2")}
                </span>
                <span style={{ fontSize: "16px", overflowWrap: "break-word" }}>
                  <strong
                    style={{ color: "#031795", cursor: "pointer" }}
                    onClick={() => setOpenReviewsModal(true)}
                  >
                    {t("forms.minutes.actions.actionsReviewsTextP3")}
                  </strong>
                  {` ${t("forms.minutes.actions.actionsReviewsTextP4")}`}
                </span>
              </div>
            )}
          </Grid>
        </Grid>
      )}

      <Grid item style={{ marginTop: "36px" }}>
        <Table
          columns={columns}
          data={formattedActions}
          actions={
            isEditMode
              ? [
                  {
                    icon: () => <Edit />,
                    tooltip: t("edit"),
                    disabled: !canCreateActionRevision || !isEditMode,
                    onClick: async (_event, rowData) => {
                      actionShowSpinner(true);
                      setEditMode(true);

                      setFormData({
                        actionId: rowData.id,
                        ...(!rowData.anyoneCanRequest && {
                          requesterName: {
                            id: rowData.idActionRequester,
                            name: rowData.actionRequester,
                          },
                        }),
                        ...(rowData.idFirstResponsible && {
                          firstResponsibleName: {
                            id: rowData.idFirstResponsible,
                            name: rowData.firstResponsible,
                          },
                        }),
                        ...(rowData.idSecondResponsible && {
                          secoundResponsibleName: {
                            id: rowData.idSecondResponsible,
                            name: rowData.secondResponsible,
                          },
                        }),
                        action: rowData.action,
                        selectedDeadline: new Date(rowData.deadline),
                        anyoneCanRequest: rowData.anyoneCanRequest || false,
                      });

                      actionShowSpinner(false);
                    },
                  },
                  {
                    icon: () => <Delete />,
                    tooltip: t("forms.dialog.delete"),
                    disabled: !canDeleteActionInMinutes || !isEditMode,
                    onClick: (_event, rowData) => handleDeleteAction(rowData),
                  },
                ]
              : []
          }
        />
      </Grid>
    </>
  );
};

const withRouterActions = withRouter(Actions);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const ActionsConnect = connect(null, mapDispatchToProps)(withRouterActions);

export default withTranslation()(ActionsConnect);
